// extracted by mini-css-extract-plugin
module.exports = {"change-profile-form-field":"_1Y2BiLdwlSZcRskgU8StDf","form-section-heading":"_3ePm6r4exqma6qNFwnYTi4","button-section":"_24PdqPkmiQjIyZo0VWo7Th"};